import { isAudit } from "PFApp/activities/helpers";
import { useTemplateFind } from "PFApp/hooks";
import { Booking } from "PFTypes";
import { useCallback } from "react";

export const useIsAuditBooking = () => {
  const findTemplate = useTemplateFind();

  return useCallback(
    (booking: Booking): boolean => isAudit(findTemplate({ id: booking.activity?.template_id })),
    [findTemplate]
  );
};
